import { render } from "./AddTopicEnrollment.vue?vue&type=template&id=cf97790a&scoped=true"
import script from "./AddTopicEnrollment.vue?vue&type=script&lang=js"
export * from "./AddTopicEnrollment.vue?vue&type=script&lang=js"

import "./AddTopicEnrollment.vue?vue&type=style&index=0&id=cf97790a&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cf97790a"]])

export default __exports__